import { WidgetType } from 'types/widget.types';

/**
 * List of widgets that should have alt text tags and can be generated via the alt text generation API
 */
export const ALT_TEXT_GENERATION_WIDGETS = [
  WidgetType.Image,
  WidgetType.AreaChart,
  WidgetType.PieChart,
  WidgetType.LineChart,
  WidgetType.BarChart,
  WidgetType.ColumnChart,
  WidgetType.StackedAreaChart,
  WidgetType.StackedBarChart,
  WidgetType.StackedColumnChart,
  WidgetType.HalfPieChart,
  WidgetType.ComboChart,
  WidgetType.MapChart,
  WidgetType.WordCloudChart,
  WidgetType.HistogramChart,
  WidgetType.ScatterBubbleChart,
  WidgetType.FunnelChart,
  WidgetType.PyramidChart,
  WidgetType.CloudBubbleChart,
  WidgetType.ScatterPlotChart,
  WidgetType.SplineChart,
  WidgetType.AreaSplineChart,
  WidgetType.TreeMapChart,
];

/**
 * Map of widgets with alt text generation
 */
export const ALT_TEXT_GENERATION_WIDGETS_MAP = new Map(
  ALT_TEXT_GENERATION_WIDGETS.map((widgetType) => [widgetType, true]),
);

/**
 * List of widgets that should have alt text tags
 */
export const TAG_ALT_TEXT_WIDGETS = [WidgetType.Icon, ...ALT_TEXT_GENERATION_WIDGETS];

/**
 * Map of widgets with  alt text tags
 */
export const TAG_ALT_TEXT_WIDGETS_MAP = new Map(TAG_ALT_TEXT_WIDGETS.map((widgetType) => [widgetType, true]));

/**
 * Classname for the Figure image on the pdf export
 */
export const TAG_FIGURE_IMAGE_CLASSNAME = 'a11y-figure-image';

export const DEFAULT_FIGURE_ALT_TEXT = 'Figure';
